// extracted by mini-css-extract-plugin
module.exports = {"root":"TicketingOverview_root__3SFos","header":"TicketingOverview_header__Bp3ik","title":"TicketingOverview_title__1Qywh"};